import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/home/collect_active_icon.png'
import _imports_1 from '@/assets/img/new/down_active_icon.png'
import _imports_2 from '@/assets/img/new/down_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-6452c8e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home_box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "seachTop" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 我的收藏 ")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "data_cont"
}
const _hoisted_4 = { class: "cont_item" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "size" }
const _hoisted_9 = { class: "collect_right" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  src: _imports_1,
  alt: ""
}
const _hoisted_12 = {
  key: 1,
  src: _imports_2,
  alt: ""
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下载", -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "pagein" }

import { onMounted, reactive } from 'vue'
import { getCollectList, getRemoveCollect } from '@/api/collect';
import { TResponse } from '@/module/common';
import { ElMessage, ElMessageBox } from 'element-plus';
import getFileTypeImg from '@/hooks/use_type_imgs'
import { fileHandle } from '@/hooks/file_preview_download'
import { TMaterialList } from '@/module/database';
import { TCollectDataType } from '@/module/collect';
type TState = {
    dataList: Array<TCollectDataType>
    listLoading: boolean
    CollectPage: number
    CollectPageSize: number
    CollectTotal: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { onPreview, addExtension, downLoad, previewPic } = fileHandle()

const state = reactive<TState>({
    dataList: [],
    listLoading: false,
    CollectPage: 1,
    CollectPageSize: 20,
    CollectTotal: 0,
})

onMounted(() => {
    getCollectData()
})

//查看图片
const previewPicClick = (row: TMaterialList, index: number) => {
    if (row.DownState && row.Type === 4) {
        state.dataList[index].isPic = !state.dataList[index].isPic
    }
}
//下载图片
const dowmClick = (item: TMaterialList, index: number) => {
    if (!item.DownState) {
        return
    }
    downLoad(item)
}

//获取收藏列表
const getCollectData = async () => {
    let data = {
        ObjType: 3,
        PageIndex: state.CollectPage,
        PageSize: state.CollectPageSize
    }
    try {
        state.listLoading = true
        let res = await getCollectList(data)
        if (res.Code === 200) {
            let { Data, Total } = res?.Data
            state.dataList = Data
            state.CollectTotal = Total
        } else {
            ElMessage.error(res.Message)
        }
    } catch (error) {

    } finally {
        state.listLoading = false
    }


}

// 取消收藏接口
const GetRemoveCollect = async (item: any, Type: number) => {
    let res: TResponse<boolean> = await getRemoveCollect({ ObjId: item.Id, ObjType: Type })
    let { Code, Data } = res
    if (Code === 200 && Data) {
        state.CollectPage = 1
        getCollectData()
        ElMessage.success('取消收藏成功')
    } else {
        ElMessage('收藏失败，请重试')
    }
}

//取消收藏提示
const cancelCollect = (item: TMaterialList, index: number) => {
    ElMessageBox.confirm('是否确定取消收藏?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
    }).then(() => {
        GetRemoveCollect(item, 3)
    })

}


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (state.dataList.length>0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.dataList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "cont_left",
                  onClick: ($event: any) => (_unref(onPreview)(item,index))
                }, [
                  (item.Type !== 4)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(getFileTypeImg)(item.Extension),
                        alt: ""
                      }, null, 8, _hoisted_6))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: ($event: any) => (previewPicClick(item,index))
                      }, [
                        _createVNode(_component_el_image, {
                          style: {"width":"44px","height":"44px","margin-right":"10px"},
                          src: item.Url,
                          "preview-src-list": [item.Url],
                          "initial-index": 4,
                          fit: "cover",
                          ref_for: true,
                          ref_key: "previewPic",
                          ref: previewPic
                        }, null, 8, ["src", "preview-src-list"])
                      ], 8, _hoisted_7)),
                  _createElementVNode("span", {
                    class: _normalizeClass({Color:item.Type === 4})
                  }, _toDisplayString(_unref(addExtension)(item)), 3),
                  _createElementVNode("span", _hoisted_8, _toDisplayString((item.Size/1024).toFixed(2)) + "M", 1)
                ], 8, _hoisted_5),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: "collect_item",
                    onClick: ($event: any) => (dowmClick(item,index))
                  }, [
                    (item.DownState)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                      : (_openBlock(), _createElementBlock("img", _hoisted_12)),
                    _hoisted_13
                  ], 8, _hoisted_10),
                  _createElementVNode("div", {
                    class: "collect_item1",
                    onClick: ($event: any) => (cancelCollect(item,index))
                  }, "取消收藏", 8, _hoisted_14)
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_el_pagination, {
              "page-size": state.CollectPageSize,
              "pager-count": 10,
              layout: "prev, pager, next",
              total: state.CollectTotal
            }, null, 8, ["page-size", "total"])
          ])
        ])), [
          [_directive_loading, state.listLoading]
        ])
      : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "暂无收藏"
        }))
  ]))
}
}

})